import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {API} from "../../app/services/api.service";
import {UserService} from "../../app/services/user.service";

/**
 * Generated class for the UserOrders page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-user-orders',
  templateUrl: 'user-orders.html',
})
export class UserOrdersPage {
  public orders: any;
  public isLoading: boolean = false;
  constructor(public navCtrl: NavController, public userService : UserService, public navParams: NavParams) {
    this.checkOrders();
  }

  checkOrders(){
    this.isLoading = true;
    this.userService.getUserOrders().then((orders) => {
      this.orders = orders;
      this.isLoading = false;
    }, (err) => {
      console.log(err);
      this.isLoading = false;
      this.orders = [];
    })
  }

  ionViewDidLoad() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/user-orders/user-orders.ts